/**
 * Detail Page Layout
 *
 * Shared layout wrapper for all detail pages with back navigation
 */

import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { StandardButton } from '../standard';

interface DetailPageLayoutProps {
  children: React.ReactNode;
  onBack: () => void;
  backLabel: string;
}

export const DetailPageLayout: React.FC<DetailPageLayoutProps> = ({
  children,
  onBack,
  backLabel
}) => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-[#0f172a]">
      {/* Back button */}
      <div className="bg-white dark:bg-[#1e293b] border-b border-gray-200 dark:border-gray-700 px-6 py-3">
        <StandardButton
          variant="ghost"
          size="sm"
          leftIcon={<ArrowLeft className="w-4 h-4" />}
          onClick={onBack}
        >
          {backLabel}
        </StandardButton>
      </div>

      {/* Content */}
      <div className="p-6">
        {children}
      </div>
    </div>
  );
};
